import './App.css';
import About from './components/About';
import Carousel from './components/Carousel';
import Contact from './components/Contact';
import Home from './components/Home';
import NavBar from './components/NavBar';
import Services from './components/Services';
import { animateScroll } from 'react-scroll';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import Header from './components/Header';

const options = {
  // your options here, for example:
  duration: 500,
  smooth: true,
};

const scrollToTop = () => {
  animateScroll.scrollToTop(options);
}

function App() {
  return (
    <div class="overflow-x-hidden">
      <Carousel></Carousel>
      <Header></Header>
      <NavBar></NavBar>
      <Home></Home>
      <About></About>
      <Services></Services>
      <Contact></Contact>
      <div class="pb-4">
        <div class="flex justify-center items-center cursor-pointer">
          <a onClick={scrollToTop} class="uppercase text-primary mr-1">Scroll To Top</a>
          <IoArrowUpCircleOutline class="text-primary text-2xl"/>
        </div>
      </div>
    </div>
  );
}

export default App;
